import React from "react";
import Hero from "../Hero/Hero";
import ProductsTabs from "../ProductsTabs/ProductsTabs";
import Testimonial from "../Testimonial/Testimonial";
const Home = () => {
  return (
    <>
      <Hero />
      <Testimonial />
    </>
  );
};

export default Home;
